import * as React from 'react';
import * as InfiniteScroll from 'react-infinite-scroll-component';
import CommentItem, {ICommentItemProp} from '../../ui/comment/commentItem';
import {observer} from 'mobx-react';
import {ICommonCommentItem, ICommonReplyItem} from '../../../apis/comment/commonApiAdapter';
import {ICommentItemReplyProp} from '../../ui/comment/commentItem/reply';
import CommentLoading from '../../ui/comment/commentLoading';
import {L} from '../../../lang';
import CommentEmpty from '../../ui/comment/commentEmpty';

if (process.env.BROWSER) {
    require('./index.less');
}
export interface ICommentListProp {
    commentItems: ICommonCommentItem[];
    hasMore?: boolean;
    onNext?: () => void;
    onClickCommentItem?: (item: ICommonCommentItem ) => void;
  onLikeItem;
}
@observer
export default class CommentList extends React.Component<ICommentListProp> {
    public render(): JSX.Element {
      const commentItems = this.props.commentItems;
      if (!this.props.hasMore && this.props.commentItems.length == 0) {
        return <CommentEmpty emptyMessage={L('comment.no_comment')}></CommentEmpty>;
      } else {
        return (<InfiniteScroll
          dataLength={commentItems.length}
          hasMore={this.props.hasMore || false}
          loader={<CommentLoading message={L('default.loading')}></CommentLoading>}
          next={this.props.onNext}
          endMessage={<CommentLoading message={''}></CommentLoading>}
          pullDownToRefresh={false}
        >
          {
            commentItems.map((prop, index) => {
              if (prop.isLocal && isLocalCommentAlreadyInList(prop, commentItems)) {
                return null; // 已重复的本地评论不显示
              } else {
                return <CommentItem
                  key={`${prop.itemId}/${prop.commentId}/${prop.isHot ? 0 : 1}`}
                  commentItem={prop}
                  onLikeItem = {this.props.onLikeItem}

                  {...this.toCommentItemProp(prop)} ></CommentItem>;
              }
            })
          }
        </InfiniteScroll>);
      }
    }

  public componentDidMount(): void {
    this.props.onNext();
  }

  private toCommentItemProp = (commentItem: ICommonCommentItem): ICommentItemProp => {
        return {
          commentItem,
          isLocal: commentItem.isLocal,
          onLikeItem: this.props.onLikeItem,
            id: commentItem.commentId,
            headerProp: {
                userImage: commentItem.userImage,
                userName: commentItem.userName,
                publishTime: commentItem.publishTime,
                isWemediaAuthor: commentItem.isWemediaAuthor,
                isWemediaUser: commentItem.isWemediaUser,
            },
            messageProp: {
                message: commentItem.message,
            },
            optionProp: {
              onLikeItem: this.props.onLikeItem,
                reply: commentItem.replyCount,
                like: commentItem.like,
            },
            replyCount: commentItem.replyCount,
            replyItemProps: this.toReplyItemProps(commentItem),
            onClickCommentItem: () => {
                if (commentItem.isLocal) {
                    return;
                }
                this.props.onClickCommentItem && this.props.onClickCommentItem(commentItem);
            },
        };
    }

    private toReplyItemProp = (replyItem: ICommonReplyItem): ICommentItemReplyProp => {
        return {
            id: replyItem.replyId,
            userName: replyItem.userName,
            messageProp: {
                message: replyItem.message,
            },
            isWemediaAuthor: replyItem.isWemediaAuthor,
            isWemediaUser: replyItem.isWemediaUser,
        };
    }

    private toReplyItemProps = (commentItem: ICommonCommentItem): ICommentItemReplyProp[] => {
        if (commentItem.replyItems) {
            return commentItem.replyItems.map<ICommentItemReplyProp>(this.toReplyItemProp);
        }
        return null;
    }
}

export function isLocalCommentAlreadyInList(local: ICommonCommentItem, list: ICommonCommentItem[]): boolean {

  for (const item of list) {
    if (!item.isLocal && local.userName === item.userName && local.message === item.message) {
      console.log('isLocalCommentAlreadyInList, true', local, list);
      return true;
    }
  }
  console.log('isLocalCommentAlreadyInList, false', local, list);
  return false;
}
